import React, { useEffect, useState } from 'react'
import './index.css'
import DropdownItem from './DropdownItem'
import axiosInstance from '../../../../util/axios'
import { API_ROUTES } from '../../../../util/constants'

const Dropdown = ({ name }) => {
	const [text, setText] = useState('')

	const [data, setData] = useState({})
	const list = data.list || []
	const title = data.label || ''
	const [isLoading, setIsLoading] = useState(true)

	function sortList(list) {
		return [...list].sort((a, b) =>
			a.localeCompare(b, 'de', { sensitivity: 'base' })
		)
	}

	function persistList(nextList) {
		if (isLoading) {
			console.warn('Data is still loading, cannot persist list yet.')
			return
		}
		setIsLoading(true)
		const updateData = {
			...data,
			list: sortList(nextList),
		}
		setData(updateData)
		axiosInstance
			.patch(API_ROUTES.DROP_DOWN_BY_NAME_UPDATE(name), updateData)
			.catch((error) => {
				console.error(error)
			})
			.finally(() => {
				setIsLoading(false)
			})
	}

	useEffect(() => {
		setIsLoading(true)
		axiosInstance
			.get(API_ROUTES.DROP_DOWN_BY_NAME(name))
			.then((result) => {
				setData(result)
			})
			.catch((error) => {
				console.error(error)
			})
			.finally(() => {
				setIsLoading(false)
			})
	}, [])

	const deleteEntry = (itemName) => {
		persistList(list.filter((e) => e !== itemName))
	}

	const createEntry = () => {
		if (text == '') return
		if (text.length > 60) {
			alert(
				'Dieser Eintrag ist zu Lang! Sie dürfen nur Einträge bis zu einer Länge von 60 Zeichen eingeben.'
			)
			setText('')
			return
		}
		if (list.includes(text)) {
			alert('Diesen Eintrag gibt es schon!')
			setText('')
			return
		}
		persistList([...list, text])
		setText('')
	}

	const updateEntry = (oldText, newText) => {
		if (newText == '') {
			return false
		}
		if (newText.length > 60) {
			return false
		}
		if (list.includes(newText)) {
			alert('Diesen Eintrag gibt es schon!')
			return false
		}
		persistList(list.map((e) => (e !== oldText ? e : newText)))
		return true
	}

	return (
		<div className='dropdownContainer'>
			<h1 className='dropdownName'>{title}</h1>
			<div id='artworksDropdown' className='dropdown'>
				<input
					className='newItemInput'
					type='text'
					onChange={(e) => {
						setText(e.target.value)
					}}
					value={text}
					onBlur={createEntry}
					onKeyDown={(e) => {
						e.key == 'Enter' && createEntry()
					}}
					disabled={isLoading}
				/>
				<div className='dropdownItemsContainer'>
					{list &&
						list.map((item, index) => (
							<DropdownItem
								key={item}
								itemName={item}
								deleteText={deleteEntry}
								updateText={updateEntry}
								disabled={isLoading}
							/>
						))}
				</div>
			</div>
		</div>
	)
}

export default Dropdown
